"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isInPopup = exports.isInIframe = exports.isBrowser = exports.isProduction = void 0;
// using string accessor fixes error with "Error: Cannot find symbol for node: NODE_ENV"
// eslint-disable-next-line dot-notation
exports.isProduction = function () { return process.env['NODE_ENV'] === 'production'; };
exports.isBrowser = function () { return typeof window !== 'undefined'; };
exports.isInIframe = function () {
    if (!exports.isBrowser())
        return false;
    try {
        return window.self !== window.top;
    }
    catch (e) {
        return true;
    }
};
exports.isInPopup = function () {
    return exports.isBrowser() && !!window.opener;
};
